let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iMMXZ")).then(() => parcelRequire('3Pvlz'));